// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__D-LjM","errorLogs":"EditorFooter_errorLogs__ubmm4"};